
import React, { Component } from 'react';
import moduleCss from "./index.module.scss";
import { Image } from 'antd-mobile';

class About extends Component {
  constructor(props) {
    super(props)
    document.title = '关于我们'
  }
  render() {
    return (
      <div className={moduleCss.ctnr}>
        <h1>青龙寺遗址概况、历史沿革与职能特点</h1>
        <h2>序</h2>
        <p>每年的三月份，是古城西安春暖花开的日子。说到西安赏樱花之处，不得不提青龙寺遗址景区，这里有西安最齐全的樱花品种，最悠久的樱花种植历史，最珍贵的樱花文化 。</p>
        <p>青龙寺遗址位于西安市雁塔区铁炉庙村北的乐游原上，系全国重点文物保护单位。景区保护利用主要经历了三个阶段：即上世纪50至70年代的考古发掘确址期、80至90年代纪念建筑和庭院建设 期以及2008年至2011年实施的《乐游原历史文化（青龙寺遗址） 保护项目》建设期等。</p>
        <p>目前已基本形成集文物遗址保护展示、中国历史文化传承及中外文化交流和宣传、仿唐建筑及园林观赏、市民游乐休闲为一体的历史文化遗址景区，总占地面积219亩 。</p>
        <h2>历史沿革</h2>
        <img className={moduleCss.imgLSYG} src={require('../../assets/about/lsyg.jpg')} />
        <p>青龙寺的前身是灵感寺。灵感寺建于隋文帝杨坚开皇二年（公元582年）。唐睿宗李旦景云二年（公元711 年）改名为青龙寺。</p>
        <p>唐代佛教兴盛是空前的，而城内的佛寺更为突出，其传播之广不仅在国内，而且对国外也有一定影响。尤其对当时日本宗教的发展影响很大。在九世纪初至中叶，日本入唐求法的“学问僧”、“请益僧”往来长安甚多，最著名的有八人，日本称为“入唐八家”，而其中六家即空海、园行、园仁、惠运、园珍、宗睿曾在青龙寺受法，使青龙寺成了向外传播佛教密宗颇有影响的寺院之一。</p>
        <p>青龙寺遗址是传承中华历史文化和开展社会公众教育宣传、见证中外文化交流的重要载体。</p>
        <h2>考古发掘</h2>
        <img className={moduleCss.imgLSYG} src={require('../../assets/about/kgfj.jpg')} />

        <p>由于唐代青龙寺与日本佛教文化有着密切关系，1924年及1925年，日本和尚和田辩瑞、加地哲定先后来西安瞻礼青龙寺。因原寺早已废毁，无从辨认，故将祭台村的石佛寺误认为青龙寺旧址。中外佛教信徒有怀疑者认为石佛寺在乐游原以北的平地上，与唐诗文中“连岗出古寺”“地高倚长坡”描述的因岗建寺的地势不一致，不同意此说。</p>
        <p>新中国成立后，遗址保护工作得到充分重视。中国社会科学院考古研究所西安唐城考古发掘队曾多次对青龙寺遗址位置进行研究和基本定位，但为了解决悬而未决的青龙寺旧址问题，于1963年对青龙寺遗址作了实际的勘察，并于1973年依据勘察线索，对青龙寺遗址的位置又进行了复查，发掘了塔址和殿堂遗址，肯定了现位置。此后又发掘出廊址、门址等8处遗址。</p>
        <p>1956年，青龙寺遗址被陕西省人民政府公布为陕西省文物保护单位。1996年，青龙寺遗址与隋大兴、唐长安城遗址合并被国务院公布为全国重点文物保护单位。</p>
        <h2>馆藏文物</h2>
        <img className={moduleCss.imgLSYG} src={require('../../assets/about/gcww.jpg')} />

        <p>走进博物馆，首先映入眼帘的是4件卧兽石，其雕刻形象均为狮子，但姿态各异，有的口衔绶带、有的互相嬉戏，充满了神异感。
          在博物馆三楼，陈列一幅名为《古青龙寺》的画，这幅3.05米长的画是首次对外亮相，堪称“镇馆之宝”。它是中国现代著名国画大师何海霞74岁时所画，于1982年修建空海纪念碑时所赠。</p>
        <p>另外一幅《空海入唐渡海图》也极为珍贵，只见苍茫大海上，海鸥飞翔，空海大师和友人坐在船上眺望远方。这幅画描述了空海大师经过34天，从日本渡海来到唐长安城的历程。</p>
        <h2>地理位置及自然环境</h2>
        <img className={moduleCss.imgLSYG} src={require('../../assets/about/dlwz.jpg')} />

        <p>青龙寺遗址景区位于西安市城东南铁炉庙村北的乐游原上，距离市中心约5公里。东接雁翔路；南临铁炉庙村，近临西影路；西临王家村；北接青龙路， 近临南二环，交通十分便利，有地铁3号线、五号线通过。</p>
        <p>区域属暖温带半湿润气候，四季分明。地貌类型为高岗原地,名曰乐游原，地势高敞，视野开阔。</p>
        <h2>文化资源</h2>
        <img className={moduleCss.imgLSYG} src={require('../../assets/about/whzy.jpg')} />

        <p>青龙寺遗址是中华民族乃至世界宝贵的文化遗产之一，随着西安市“世界闻名古都”、“国际旅游城市”、“遗产旅游国际典范城市”等目标的提出，青龙寺遗址景区的内涵也在不断的完善和丰富。</p>
        <p>1985年，日本赠送青龙寺遗址近千株樱花植于保护区内，每年三、四月间，樱花 盛开，春色满园，姹紫嫣红，风光旖旎。</p>
        <h2>乐游原文化</h2>
        <p>乐游原因地处隋唐长安城内的第五条高坡的最高处，是唐代都人登高赏景、集会游乐的休闲场所。唐诗中更有“乐游原上望，望尽帝都春”“自然成高致，向下看浮云。迤逦峰岫列，参差闾井分”“乐游形胜地，表里望郊宫。北阙连天顶，南山对掌中。”的动人诗句，来描述在这里观赏到的壮丽的景色</p>
        <h2>区域功能</h2>
        <img className={moduleCss.imgLSYG} src={require('../../assets/about/qygn.jpg')} />

        <p>青龙寺遗址庭院区占地面积约1.8公顷，在西安市民心目中属于高品质、 建设精良的庭院，整个园林意境营造十分突出， 集纪念、游赏、文化交流的功能于一体，是不可多得的、设计经典的传统园林。</p>
        <p>乐游原历史文化体验区占地面积约8.4公顷，于2011年完成了《乐游原历史文化（青龙寺遗址）保护项目》。这标志着该景区已经成为集遗址保护展示、公园、博物馆、生活休闲等于一体的历史文化景区。同时也是西安市主要的观赏樱花胜地之一。</p>
        <p>青龙寺遗址展示区占地面积约2.4公顷，以塔址为中心，形成一个较完整的佛寺院落展示。展示区内布置道路与景观绿化，整体风格简洁，绿化以常绿灌木、草坪地被为主。</p>
        <h2>一期开发及建设现状---</h2>
        <img className={moduleCss.imgLSYG} src={require('../../assets/about/yq.jpg')} />

        <p>在倡导文化复兴、文化强国并增进中外文化交流的情况下，青龙寺遗址有过两次保护性规划，它们所处时代不同，侧重点也不同。</p>
        <p>1982年5月，在中日邦交正常化十周年之际，由日方提议， 中日两国政府共同投资在保护区内修建了由我国著名建筑大师张锦秋先生负责总体规划设计的纪念性院落（东院）的仿唐式陈列室、房舍、环廊建筑设计等。</p>
        <p>1984年建筑考古学家杨鸿勋先生对遗址四号殿堂进行复原研 究，并根据复原方案修建了“惠果空海纪念堂”（西院）。次年日 本各界友人赠送十余品种约千株樱花栽植于保护区内。</p>
        <p>1993年11月市政府与日本政府及民众捐资共同修建青龙寺庭院（中院），将纪念碑和纪念堂东西两院连接起来，使纪念碑、纪念堂、云峰阁、诗碑画廊等主体建筑连为一体，形成错落有致的三个院落。</p>
        <p>1995年11月市政府与日方共建了钟楼。</p>
        <p>1997年，市政府将惠果空海纪念堂院落（西院）移交西安市 宗教局管理使用。</p>
        <p>2000年4月共建了中日友好牡丹园。至此，建成区共占地 41亩，成为西安第一例仿唐建筑群。2019年“空海纪念碑院”被评为第四批“二十世纪建筑遗产”。</p>

        <h2>二期开发及建设现状--</h2>
        <img className={moduleCss.imgLSYG} src={require('../../assets/about/eq.jpg')} />

        <p>自2008年始，西安市委、市政府为保护乐游原和青龙寺遗址这一重要的历史文化资源，进一步加大文物保护利用力度，启动实施了《乐游原历史文化（青龙寺遗址）保护项目》。其面积由上述建成区的41亩扩大到目前的219亩。实施完成了青龙寺遗址保护展示工程；古原楼（遗址博物馆）、东大门、北大门等建设工程以及水系湖景、仿唐石桥、绿化美化、参观游览等配套工程。扩建工程于2011年底完成并向社会公众免费开放。</p>
        <p>作为地理位置优越，规模适中，交通便利，周边市民和游客使用率高、季节性强、文化目的突出、乐于前往的一处休闲游憩绿地，青龙寺遗址景区不仅丰富了市民和游客的休闲、参观、娱乐体验及游赏品质，继而提升游客的中华历史文化认同感和文化参与感，成为西安市一处历史文化游赏胜地。</p>
      </div>
    )
  }
}
export default About